import { Divider } from "primereact/divider"
import logoInfo from '../assets/quod.svg';
export const InformacaoQuod = () => {
    return (
        <div>
        <Divider className="automotiva" align="left">
        <div className="flex-score justify-content-between justify-content-center">

          <img
            style={{ width: "150px", position: "relative" }}
            src={logoInfo}
            alt="logo"
          />
        </div>
      </Divider>
      </div>
    )
}